import { addNewMessages, setPageMessages } from "../../slices/messageSlice";
import { setActivePage } from "../../deprecated/activePageSlice";
import { hydrateMessageArray } from "../../utils/messageUtils";

export const fetchNewMessages = (practitionerId, fhirClient, direction, includeFhirExtras = true) => {
    return async (dispatch, getState) => {
        if (!practitionerId || !fhirClient || !direction) {
            console.warn("⚠️ Missing required params for fetchNewMessages");
            return;
        }

        try {
            const msgState = getState().messages;
            const currentPageUrl = msgState.currentPageUrl;
            const participantParam = direction === "sent" ? "sender" : "recipient";

            const queryUrl =
                currentPageUrl ||
                `Communication?${participantParam}=Practitioner/${practitionerId}&_count=10&_sort=-sent&sent=ge1900-01-01`;

            const existingPage = msgState.pageMap[currentPageUrl];
            const existingIds = existingPage?.ids || [];

            const existingMessages = existingIds
                .map(id => msgState.byId[id])
                .filter(Boolean);

            const response = await fhirClient.request(queryUrl);
            const rawMessages = (response.entry || []).map(e => e.resource);

            if (!rawMessages.length) return;

            const newMessages = rawMessages.filter(msg => !existingIds.includes(msg.id));
            if (!newMessages.length) return;

            const combinedRaw = [...newMessages, ...existingMessages];

            const hydratedCombined = await hydrateMessageArray({
                messages: combinedRaw,
                contextProvider: { id: practitionerId },
                store: getState,
                fhirClient,
                dispatch,
                isMounted: true,
                includeFhirExtras  // ← new flag propagated
            });

            if (!hydratedCombined.length) return;

            const combinedIds = hydratedCombined.map(m => m.id);

            dispatch(
                setPageMessages({
                    pageUrl: currentPageUrl,
                    messages: hydratedCombined,
                    nextPageUrl: existingPage?.nextPageUrl || null,
                    prevPageUrl: existingPage?.prevPageUrl || null,
                    total: combinedIds.length
                })
            );

            dispatch(
                setActivePage({
                    currentPageUrl,
                    nextPageUrl: existingPage?.nextPageUrl || null,
                    prevPageUrl: existingPage?.prevPageUrl || null,
                    total: combinedIds.length,
                    currentPageNumber: 1
                })
            );

            dispatch(addNewMessages(hydratedCombined));
        } catch (err) {
            console.error("💥 fetchNewMessages failed:", err);
        }
    };
};
